import { AsYouType } from 'libphonenumber-js';
export default function phoneAsYouTypeFormatter(candidate, country) {
  return new AsYouType(country).input(candidate);
}